var UitkEGMapsQualifier;
(function (UitkEGMapsQualifier) {
    UitkEGMapsQualifier["OBFUSCATED"] = "obfuscate";
    UitkEGMapsQualifier["OBFUSCATED_PIN"] = "pinObfuscate";
    UitkEGMapsQualifier["OBFUSCATED_PRICE"] = "priceObfuscate";
    UitkEGMapsQualifier["SAVED"] = "saved";
    UitkEGMapsQualifier["NOT_CLUSTERED"] = "not_clustered";
    UitkEGMapsQualifier["PINNED"] = "pinned";
    UitkEGMapsQualifier["FOCAL"] = "focal";
    UitkEGMapsQualifier["HIDDEN"] = "hidden";
    UitkEGMapsQualifier["VACATION_RENTAL"] = "vacation_rental";
    UitkEGMapsQualifier["AIRPORT"] = "transport__airport";
    UitkEGMapsQualifier["RESTAURANT"] = "service__restaurant";
    UitkEGMapsQualifier["HOTEL"] = "lob_hotels";
    UitkEGMapsQualifier["CAR"] = "lob_cars";
    UitkEGMapsQualifier["CRUISE"] = "portOfCall";
    UitkEGMapsQualifier["TRANSIT"] = "transport__metroStation";
    UitkEGMapsQualifier["FLIGHTPATH"] = "flightPath";
    UitkEGMapsQualifier["GROCERY"] = "service__groceryStore";
    UitkEGMapsQualifier["TRANSPORTATION"] = "transport__trainStation";
    UitkEGMapsQualifier["PEOPLE"] = "activities__redeemingPoint";
    UitkEGMapsQualifier["ACTIVITY"] = "activities__activity";
    UitkEGMapsQualifier["PARKING"] = "service__parking";
    UitkEGMapsQualifier["METRO_STATION"] = "transport__metroStation";
    UitkEGMapsQualifier["BUS_STATION"] = "transport__busStation";
    UitkEGMapsQualifier["LANDMARK"] = "placeOfInterest__landmark";
    UitkEGMapsQualifier["POINT_OF_INTEREST"] = "tourism__placeOfInterest";
})(UitkEGMapsQualifier || (UitkEGMapsQualifier = {}));
var UitkEGMapsUitkIconType;
(function (UitkEGMapsUitkIconType) {
    UitkEGMapsUitkIconType["AIRPORT"] = "lob_flights";
    UitkEGMapsUitkIconType["RESTAURANT"] = "local_dining";
    UitkEGMapsUitkIconType["HOTEL"] = "lob_hotels";
    UitkEGMapsUitkIconType["CAR"] = "lob_cars";
    UitkEGMapsUitkIconType["TRANSIT"] = "train";
    UitkEGMapsUitkIconType["FLIGHTPATH"] = "flightPath";
    UitkEGMapsUitkIconType["LANDMARK"] = "place";
    UitkEGMapsUitkIconType["GROCERY"] = "shopping_cart";
    UitkEGMapsUitkIconType["TRANSPORTATION"] = "train";
    UitkEGMapsUitkIconType["PEOPLE"] = "people";
    UitkEGMapsUitkIconType["ACTIVITY"] = "lob_activities";
    UitkEGMapsUitkIconType["PARKING"] = "local_parking";
    UitkEGMapsUitkIconType["METRO_STATION"] = "train";
    UitkEGMapsUitkIconType["BUS_STATION"] = "directions_bus";
    UitkEGMapsUitkIconType["POI"] = "circle_filled";
    UitkEGMapsUitkIconType["SOLD_OUT"] = "remove";
    UitkEGMapsUitkIconType["VACATION_RENTAL"] = "lob_vacation_rentals";
    UitkEGMapsUitkIconType["SAVED"] = "favorite";
})(UitkEGMapsUitkIconType || (UitkEGMapsUitkIconType = {}));

export { UitkEGMapsQualifier, UitkEGMapsUitkIconType };
